export default "__VITE_ASSET__8e3d4429__"